import constants from './constants'

// eslint-disable-next-line import/prefer-default-export
export const setIsChatHidden = () => ({
  type: constants.SET_HIDE_CHAT,
})
